<template>
  <div class="card mini-stats-wid">
    <loading
      :active.sync="isLoading"
      :is-full-page="false"
      :height="45"
      :width="45"
      color="#398BD7"
    ></loading>
    <div class="card-body">
      <div class="d-flex align-items-center justify-content-between">
        <date-picker
          v-model="date"
          :editable="false"
          @input="filterSelect"
          type="year"
          format="YYYY"
          placeholder="Pilih Tahun"
          :clearable="false"
        ></date-picker>
      </div>
      <div class="media mt-3">
        <div class="media-body">
          <h5 class="text-muted font-weight-medium">Revenue</h5>
          <h4 class="mb-0">Rp. {{ $root.numberWithCommas(total) }}</h4>
        </div>

        <div
          class="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon"
        >
          <span class="avatar-title rounded-circle bg-primary">
            <i class="bx bx-archive-in font-size-24"></i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      table_module: "dashboards",
      date: new Date(),
      isLoading: true,
      total: 0,
    };
  },
  mounted() {
    this.showChart();
  },
  methods: {
    filterSelect(date) {
      this.showChart(date);
    },
    showChart: function (date_filter = null) {
      this.isLoading = true;
      let params = {};

      if (date_filter !== null) {
        params["years"] = this.$moment(this.date).format("YYYY");
      }

      this.axios
        .post("/" + this.table_module + "/revenue", params)
        .then((response) => {
          this.isLoading = false;
          this.total = response.data.data;
        });
    },
  },
};
</script>